var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid frieze h-100 pt-5",attrs:{"data-cy":"account-content"}},[_c('div',{staticClass:"row justify-content-center"},[_c('h3',[_vm._v(_vm._s(_vm.$t("account.title")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }